import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { EViewType } from "shared/enum/view-type/view-type.enum";

@Injectable({
  providedIn: null
})
export abstract class IViewTypeService {
  abstract viewTypeGet(): Observable<EViewType>;
  abstract viewTypeSet(value: EViewType | undefined): void;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IViewTypeServiceToken = new InjectionToken<IViewTypeService>('IViewTypeServiceToken');
